import React from 'react';
import { Heading } from 'wix-style-react';
import styles from './MenuTitle.scss';

export const MenuTitle = (props) => {
  return (
    <div className={styles.menuTitle}>
      <Heading appearance="H4">{props.children}</Heading>
    </div>
  );
};
